import React from "react";
import {
  Header,
  Container,
  Button,
  Icon,
  Grid,
  Segment,
  GridColumn
} from "semantic-ui-react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    console.log("didcatch error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const isDev = process.env.NODE_ENV !== "production";
      return (
        <Container
          style={{
            color: "#444",
            width: "450px",
            height: "100%",
            verticalAlign: "middle"
          }}
          textAlign="center"
        >
          <Segment textAlign="center" style={{ marginTop: 200 }}>
            <Grid columns="1">
              <GridColumn style={{ padding: "30px 0 30px 0" }}>
                <Icon name="exclamation triangle" size="massive" color="grey" />
              </GridColumn>
              <GridColumn>
                <Header>Something went wrong!</Header>
              </GridColumn>
              <GridColumn>
                <p style={{ color: "grey", paddinTop: 0 }}>
                  Our software team is working on it. <br />
                  Please try again later.
                </p>
              </GridColumn>
              {isDev && (
                <GridColumn style={{ textAlign: "left", maxHeight: 280, overflow: "auto" }}>
                  <pre
                    style={{
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      fontSize: 12,
                      background: "#f8f8f8",
                      padding: 10,
                      borderRadius: 6,
                      textAlign: "left",
                    }}
                  >
                    {String(this.state.error || "Unknown error")}
                    {"\n\n"}
                    {this.state.error && this.state.error.stack
                      ? this.state.error.stack
                      : ""}
                    {"\n\n"}
                    {this.state.errorInfo && this.state.errorInfo.componentStack
                      ? this.state.errorInfo.componentStack
                      : ""}
                  </pre>
                </GridColumn>
              )}
              <GridColumn>
                <Button
                  fluid
                  onClick={() => (window.location = "/")}
                  primary
                  size="large"
                >
                  <Icon name="home" /> Home
                </Button>
              </GridColumn>
              <GridColumn>
                <Button
                  fluid
                  onClick={() => window.location.reload()}
                  basic
                  size="large"
                >
                  <Icon name="redo" /> Reload
                </Button>
              </GridColumn>
            </Grid>
          </Segment>
        </Container>
      );
    }
    return this.props.children;
  }
}
export default ErrorBoundary;
